(function () {
let $272fb929d70e4b58$var$isOpen = false;
const $272fb929d70e4b58$var$mobileMenuBtn = document.getElementById("mobile-menu");
$272fb929d70e4b58$var$mobileMenuBtn?.addEventListener("click", (evt)=>{
    evt.preventDefault();
    $272fb929d70e4b58$var$toggleMenu();
});
function $272fb929d70e4b58$var$toggleMenu() {
    const navbarMenu = document.querySelector(".navbar-menu");
    const navbarBrand = document.querySelector(".navbar-brand");
    if ($272fb929d70e4b58$var$mobileMenuBtn != null) {
        if ($272fb929d70e4b58$var$isOpen) {
            $272fb929d70e4b58$var$mobileMenuBtn.classList.remove("is-active");
            navbarMenu?.classList.remove("is-active");
            navbarBrand?.classList.remove("is-active");
            $272fb929d70e4b58$var$mobileMenuBtn.ariaExpanded = "false";
        } else {
            $272fb929d70e4b58$var$mobileMenuBtn.classList.add("is-active");
            navbarMenu?.classList.add("is-active");
            navbarBrand?.classList.add("is-active");
            $272fb929d70e4b58$var$mobileMenuBtn.ariaExpanded = "true";
        }
        $272fb929d70e4b58$var$isOpen = !$272fb929d70e4b58$var$isOpen;
    }
}
function $272fb929d70e4b58$var$toggleDropdownMobile(evt) {
    evt.preventDefault();
    if (window.matchMedia("(max-width: 1023px)")) {
        const dropdownControl = evt.target;
        const mobileDropdown = dropdownControl?.parentElement?.querySelector(".nav-dropdown-mobile");
        // const dropdownControl: HTMLElement | null = document.getElementById("schools-link");
        if (mobileDropdown?.classList.contains("show-tablet-below")) {
            mobileDropdown?.classList.remove("show-tablet-below");
            dropdownControl && (dropdownControl.ariaExpanded = "false");
        } else {
            mobileDropdown?.classList.add("show-tablet-below");
            dropdownControl && (dropdownControl.ariaExpanded = "true");
        }
    }
}
const $272fb929d70e4b58$var$schoolsLink = document.querySelector("#schools-link");
$272fb929d70e4b58$var$schoolsLink?.addEventListener("click", $272fb929d70e4b58$var$toggleDropdownMobile);
const $272fb929d70e4b58$var$directorsLink = document.querySelector("#directors-link");
$272fb929d70e4b58$var$directorsLink?.addEventListener("click", $272fb929d70e4b58$var$toggleDropdownMobile);


const $06b50df5725d1b20$var$homeBackgroundVideo = document.getElementById('home-background-video');
const $06b50df5725d1b20$var$homeBackgroundImage = document.getElementById('home-background-image');
$06b50df5725d1b20$var$homeBackgroundVideo?.addEventListener("canplay", ()=>{
    if ($06b50df5725d1b20$var$homeBackgroundImage) {
        if (window.innerWidth >= 850) {
            $06b50df5725d1b20$var$homeBackgroundImage.style.display = "none";
            $06b50df5725d1b20$var$homeBackgroundVideo.style.display = "block";
        }
    }
});
const $06b50df5725d1b20$var$whoBtn = document.getElementById("who-button");
$06b50df5725d1b20$var$whoBtn?.addEventListener("click", ()=>{
    window.location.href = "#who-we-are";
    setTimeout(()=>{
        window.scrollBy(0, -45);
    }, 300);
});
async function $06b50df5725d1b20$var$signup(evt) {
    evt.preventDefault();
    const form = evt.target;
    const button = form.querySelector('button[type="submit"]');
    button?.classList.add("is-loading");
    const formData = new FormData(form);
    const name = formData.get('signup-name');
    const email = formData.get('signup-email');
    const response = await fetch("/", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            name: name,
            email: email
        })
    });
    button?.classList.remove("is-loading");
    if (response.ok) {
        const success = document.querySelector("#form-success");
        success?.classList.remove("hide");
        const textInputs = form.querySelectorAll("input");
        textInputs.forEach((text)=>text.value = "");
    } else {
        const fail = document.querySelector("#form-failure");
        fail?.classList.remove('hide');
    }
}
const $06b50df5725d1b20$var$form = document.querySelector('#sign-up-form');
if ($06b50df5725d1b20$var$form) $06b50df5725d1b20$var$form?.addEventListener("submit", $06b50df5725d1b20$var$signup);


function $e978ce2f3ff39385$export$2061056d06d7cdf7(day) {
    let dayOfMonth = "";
    switch(day){
        case 0:
            dayOfMonth = "Sunday";
            break;
        case 1:
            dayOfMonth = "Monday";
            break;
        case 2:
            dayOfMonth = "Tuesday";
            break;
        case 3:
            dayOfMonth = "Wednesday";
            break;
        case 4:
            dayOfMonth = "Thursday";
            break;
        case 5:
            dayOfMonth = "Friday";
            break;
        case 6:
            dayOfMonth = "Saturday";
            break;
    }
    return dayOfMonth;
}


let $aed85289451a7507$var$courseMenuActive = false;
let $aed85289451a7507$var$cohortInfoModalActive = true;
const $aed85289451a7507$var$panelControls = document.querySelectorAll(".school-panel");
$aed85289451a7507$var$panelControls.forEach((panel, index)=>{
    const header = panel.querySelector(".school-header");
    header?.addEventListener("click", ()=>{
        $aed85289451a7507$var$togglePanel(header);
    });
});
function $aed85289451a7507$var$togglePanel(panelControl) {
    // @ts-ignore
    const panelName = panelControl.attributes['aria-controls'].value;
    const panel = document.querySelector(`#${panelName}`);
    const isHidden = panel?.classList.contains("hide");
    if (isHidden) {
        panel?.classList.remove("hide");
        const icon = panelControl.querySelector("i");
        icon?.classList.add("fa-angle-up");
        icon?.classList.remove("fa-angle-down");
    } else {
        panel?.classList.add("hide");
        const icon = panelControl.querySelector("i");
        icon?.classList.add("fa-angle-down");
        icon?.classList.remove("fa-angle-up");
    }
}
function $aed85289451a7507$var$toggleCoursesMenu(evt) {
    const courseMenu = document.querySelector("#courses-menu");
    if ($aed85289451a7507$var$courseMenuActive) courseMenu?.classList.remove("is-active");
    else courseMenu?.classList.add("is-active");
    $aed85289451a7507$var$courseMenuActive = !$aed85289451a7507$var$courseMenuActive;
    evt.stopPropagation();
}
function $aed85289451a7507$var$filterCohortsByLanguage(evt) {
    const filterSelection = evt.target;
    const filterType = filterSelection.dataset.id;
    const locationItems = document.querySelectorAll(".school-location-item");
    locationItems.forEach((l)=>{
        l.style.display = "block";
    });
    const isOnline = filterType?.includes("online");
    if (filterType != "online-all" && filterType != "in-person-all") locationItems.forEach((l)=>{
        if (isOnline && l.dataset.language?.includes("online")) {
            if (l.dataset.language != filterType) l.style.display = "none";
        } else if (!isOnline && l.dataset.language?.includes("in-person")) {
            if (l.dataset.language != filterType) l.style.display = "none";
        }
    });
}
function $aed85289451a7507$var$filterCohortsByCity(evt) {
    const filterSelection = evt.target;
    const filterCity = filterSelection.dataset.city?.toLowerCase();
    $aed85289451a7507$var$radioCityBtns.forEach((b)=>b.classList.remove("is-primary"));
    filterSelection.classList.add("is-primary");
    const locationItems = document.querySelectorAll(".school-location-item");
    locationItems.forEach((l)=>{
        l.style.display = "block";
    });
    if (filterCity != "all") locationItems.forEach((l)=>{
        if (l.dataset.city) {
            if (l.dataset.city?.toLowerCase() != filterCity) l.style.display = "none";
        }
    });
}
function $aed85289451a7507$var$closeCohortInfoModal() {
    const cohortInfoModal = document.getElementById('cohort-info');
    if (cohortInfoModal) cohortInfoModal.classList.remove("is-active");
    $aed85289451a7507$var$cohortInfoModalActive = false;
    window.removeEventListener("hashchange", ()=>{});
}
const $aed85289451a7507$var$radioLanguageBtns = document.querySelectorAll("input[name=cohort-filter]");
$aed85289451a7507$var$radioLanguageBtns.forEach((r)=>{
    r.addEventListener("change", $aed85289451a7507$var$filterCohortsByLanguage);
});
const $aed85289451a7507$var$radioCityBtns = document.querySelectorAll(".city-tag");
$aed85289451a7507$var$radioCityBtns.forEach((r)=>{
    r.addEventListener("click", $aed85289451a7507$var$filterCohortsByCity);
});
const $aed85289451a7507$var$menuControl = document.querySelector("#courses-menu-btn");
$aed85289451a7507$var$menuControl?.addEventListener("click", $aed85289451a7507$var$toggleCoursesMenu);
if (window.location.pathname.includes("schools")) {
    const body = document.querySelector("body");
    body?.addEventListener("click", (evt)=>{
        if ($aed85289451a7507$var$courseMenuActive) $aed85289451a7507$var$toggleCoursesMenu(evt);
        if ($aed85289451a7507$var$cohortInfoModalActive) $aed85289451a7507$var$closeCohortInfoModal();
    });
    body?.addEventListener("keydown", (evt)=>{
        if ($aed85289451a7507$var$cohortInfoModalActive) {
            if (evt.key == 'Escape') $aed85289451a7507$var$closeCohortInfoModal();
        }
    });
}
const $aed85289451a7507$var$cohortInfoModal = document.getElementById('cohort-info');
if ($aed85289451a7507$var$cohortInfoModal) $aed85289451a7507$var$cohortInfoModal.addEventListener("click", (evt)=>evt.stopPropagation());
const $aed85289451a7507$var$modalCloseBtn = document.querySelectorAll('.cohort-modal-close');
$aed85289451a7507$var$modalCloseBtn.forEach((btn)=>{
    btn.addEventListener("click", $aed85289451a7507$var$closeCohortInfoModal);
});
const $aed85289451a7507$var$cohortItems = document.querySelectorAll(".school-location-item");
$aed85289451a7507$var$cohortItems.forEach((item)=>{
    item.addEventListener("click", async ()=>{
        window.location.hash = "cohortInfo";
        const schoolId = item.dataset.schoolid;
        const courseId = item.dataset.courseid;
        const cohortId = item.dataset.id;
        // console.log(schoolId, courseId, cohortId);
        const response = await fetch(`/schools/api/cohort-detail/${schoolId}/${courseId}/${cohortId}`);
        const data = await response.json();
        const cohortModal = document.getElementById("cohort-info");
        if (cohortModal) {
            cohortModal.getElementsByClassName("cohort-name")[0].innerHTML = data.name;
            cohortModal.getElementsByClassName("cohort-notes")[0].innerHTML = data.notes ?? "";
            const instructors = cohortModal.getElementsByClassName("instructor")[0];
            const list = data.instructors.map((ins)=>{
                return `<p>${ins.name}</p>`;
            });
            instructors.innerHTML = `
                <h5>Instructors</h5>
                ${list.join("")}
            `;
            const dates = cohortModal.querySelector(".dates");
            const dateItems = data.datesDisplay.map((d, index)=>{
                let location = "";
                if (window.location.pathname.toLowerCase().includes("spiritual-direction") && (window.location.pathname.toLowerCase().includes("year-1") || window.location.pathname.toLowerCase().includes("year-2"))) {
                    if (data.locationType == 'Hybrid') {
                        if (data.locationDisplay) location = `(${data.locationDisplay[index]})`;
                    }
                }
                return `<li>${d} ${location}</li>`;
            });
            const listView = dates?.querySelector("ul");
            if (listView) listView.innerHTML = dateItems.join("");
            const actionsView = document.querySelector(".actions");
            if (actionsView && !data.isOpen) actionsView.style.display = "none";
            if (actionsView) {
                const anchorElement = actionsView.querySelector("a");
                anchorElement.href = data.registrationUrl;
            }
            if (data.datesDisplay.length == 0) {
                const dateElement = document.querySelector("#cohort-info .dates");
                if (dateElement) dateElement.classList.add("hide");
            } else {
                const dateElement = document.querySelector("#cohort-info .dates");
                if (dateElement) dateElement.classList.remove("hide");
            }
            //NOTES
            if (window.location.pathname.toLowerCase().includes("spiritual-direction")) {
                const daysHtml = document.querySelector(".days");
                let weekOfMonth = "";
                if (data.dates.length > 0) {
                    const dateTest = data.dates[0];
                    if (new Date(dateTest.start).getTime() == new Date(dateTest.end).getTime()) {
                        const dayNumber = new Date(dateTest.end).getUTCDay();
                        const dateNumber = new Date(dateTest.start).getUTCDate();
                        const dayDateTotal = dayNumber + dateNumber;
                        if (dayDateTotal < 13) weekOfMonth = "1st";
                        else if (dayDateTotal < 20) weekOfMonth = "2nd";
                        else if (dayDateTotal < 27) weekOfMonth = "3rd";
                        else if (dayDateTotal < 34) weekOfMonth = "4th";
                        const meetingDay = `Cohort takes place the ${weekOfMonth} ${(0, $e978ce2f3ff39385$export$2061056d06d7cdf7)(dayNumber)} of each month`;
                    //if(daysHtml) daysHtml.innerHTML = meetingDay;
                    } else {
                        //show days only
                        const startDay = new Date(dateTest.start).getUTCDay();
                        const endDay = new Date(dateTest.end).getUTCDay();
                        const meetingDays = `Cohort takes place ${(0, $e978ce2f3ff39385$export$2061056d06d7cdf7)(startDay)}-${(0, $e978ce2f3ff39385$export$2061056d06d7cdf7)(endDay)}`;
                    //if(daysHtml) daysHtml.innerHTML = meetingDays;
                    }
                } else daysHtml.innerHTML = "";
                const timezoneHtml = document.querySelector(".timezone");
                if (data.locationType == 'Online') {
                    if (data.timezone) {
                        const timezone = `Cohort meets in the US ${data.timezone} timezone`;
                        if (timezoneHtml) timezoneHtml.innerHTML = timezone;
                    }
                } else if (timezoneHtml) timezoneHtml.innerHTML = "";
            }
            cohortModal.classList.add("is-active");
        }
        window.addEventListener("hashchange", (evt)=>{
            $aed85289451a7507$var$closeCohortInfoModal();
        });
    });
});


const $b90f4c805c29db8f$var$bios = [];
const $b90f4c805c29db8f$var$teacherLinks = document.querySelectorAll(".teacher-item-btn");
let $b90f4c805c29db8f$var$currentBio;
function $b90f4c805c29db8f$var$showBio(id) {
    const bioView = document.getElementById("bio-view");
    const userBox = document.getElementById(id);
    const btnEle = userBox?.querySelector("button");
    const imageElement = userBox?.querySelector("img");
    const inputElement = userBox?.querySelector("input");
    const viewName = bioView?.querySelector("h3");
    const viewImage = bioView?.querySelector("img");
    const viewBio = bioView?.querySelector("p");
    const viewEmail = bioView?.querySelector("#viewTeacherEmail label");
    if (viewName) viewName.innerHTML = btnEle?.innerHTML ?? "";
    if (viewImage) viewImage.src = imageElement?.src ?? "";
    if (viewBio) viewBio.innerHTML = inputElement?.value ?? "";
    if (viewEmail) viewEmail.innerHTML = "&nbsp View Email";
    bioView?.classList.add('is-active');
    $b90f4c805c29db8f$var$currentBio = id;
}
function $b90f4c805c29db8f$var$getBio(evt) {
    const btnElement = evt.target;
    $b90f4c805c29db8f$var$showBio(btnElement?.dataset.id ?? "1");
}
$b90f4c805c29db8f$var$teacherLinks.forEach((t)=>{
    const btn = t;
    t.addEventListener("click", $b90f4c805c29db8f$var$getBio);
    $b90f4c805c29db8f$var$bios.push(btn?.dataset.id ?? "");
});
document.getElementById("modal-close")?.addEventListener("click", ()=>document.getElementById("bio-view")?.classList.remove("is-active"));
function $b90f4c805c29db8f$var$nextBio() {
    for(let i = 0; i < $b90f4c805c29db8f$var$bios.length; i++){
        if ($b90f4c805c29db8f$var$currentBio == $b90f4c805c29db8f$var$bios[$b90f4c805c29db8f$var$bios.length - 1]) {
            $b90f4c805c29db8f$var$showBio($b90f4c805c29db8f$var$bios[0]);
            break;
        }
        if ($b90f4c805c29db8f$var$currentBio == $b90f4c805c29db8f$var$bios[i]) {
            $b90f4c805c29db8f$var$showBio($b90f4c805c29db8f$var$bios[i + 1]);
            break;
        }
    }
}
function $b90f4c805c29db8f$var$previousBio() {
    for(let i = 0; i < $b90f4c805c29db8f$var$bios.length; i++){
        if ($b90f4c805c29db8f$var$currentBio == $b90f4c805c29db8f$var$bios[0]) {
            $b90f4c805c29db8f$var$showBio($b90f4c805c29db8f$var$bios[$b90f4c805c29db8f$var$bios.length - 1]);
            break;
        }
        if ($b90f4c805c29db8f$var$currentBio == $b90f4c805c29db8f$var$bios[i]) {
            $b90f4c805c29db8f$var$showBio($b90f4c805c29db8f$var$bios[i - 1]);
            break;
        }
    }
}
document.getElementById('next')?.addEventListener("click", $b90f4c805c29db8f$var$nextBio);
document.getElementById('previous')?.addEventListener("click", $b90f4c805c29db8f$var$previousBio);
document.addEventListener("keydown", $b90f4c805c29db8f$var$navigateBio);
function $b90f4c805c29db8f$var$navigateBio(evt) {
    const bioView = document.getElementById('bio-view');
    if (bioView?.classList.contains("is-active")) {
        if (evt.code === "ArrowRight") $b90f4c805c29db8f$var$nextBio();
        else if (evt.code == "ArrowLeft") $b90f4c805c29db8f$var$previousBio();
        else if (evt.code === "Escape") bioView.classList.remove("is-active");
    }
}
const $b90f4c805c29db8f$var$viewEmailBtn = document.querySelector("#viewTeacherEmail");
$b90f4c805c29db8f$var$viewEmailBtn?.addEventListener("click", async ()=>{
    const response = await fetch(`/teacher/find/${$b90f4c805c29db8f$var$currentBio}`);
    const email = await response.text();
    const text = $b90f4c805c29db8f$var$viewEmailBtn.querySelector("label");
    if (text) text.innerHTML = `&nbsp;<a href="mailto:${email}">${email}</a>`;
});


const $d2aa86d387f57aab$var$moreInfoButtons = document.querySelectorAll('.donation-more-info');
$d2aa86d387f57aab$var$moreInfoButtons.forEach((btn)=>{
    btn.addEventListener("click", (evt)=>{
        const infoBtn = evt.target;
        const modalId = infoBtn.dataset.id;
        const modal = document.querySelector(`#${modalId ?? ""}`);
        modal?.classList.add("is-active");
    });
});
const $d2aa86d387f57aab$var$closeInfoButtons = document.querySelectorAll('.close-info');
$d2aa86d387f57aab$var$closeInfoButtons.forEach((btn)=>{
    btn.addEventListener("click", (evt)=>{
        const closeBtn = evt.target;
        const modalId = closeBtn.dataset.id;
        const modal = document.querySelector(`#${modalId ?? ""}`);
        modal?.classList.remove("is-active");
    });
});


const $3abb060d6e435300$var$termsModal = document.getElementById('terms');
const $3abb060d6e435300$var$termsBtn = document.getElementById('terms-button');
$3abb060d6e435300$var$termsBtn?.addEventListener("click", (evt)=>{
    evt.preventDefault();
    $3abb060d6e435300$var$termsModal?.classList.add("is-active");
});
const $3abb060d6e435300$var$modalCloseBtn = document.getElementById('modal-close');
$3abb060d6e435300$var$modalCloseBtn?.addEventListener("click", (evt)=>{
    $3abb060d6e435300$var$termsModal?.classList.remove("is-active");
});
document.addEventListener("keyup", (evt)=>{
    if (evt.key === "Escape") $3abb060d6e435300$var$termsModal?.classList.remove("is-active");
});
let $3abb060d6e435300$var$isAgreed = false;
let $3abb060d6e435300$var$currentDirectorId = 0;
function $3abb060d6e435300$var$toggleListingButton(status) {
    const listingBtn = document.getElementById('directors-listing-button');
    if (listingBtn) listingBtn.disabled = !status;
}
document.getElementById('agree-check')?.addEventListener("change", (evt)=>{
    const input = evt.target;
    $3abb060d6e435300$var$toggleListingButton(input.checked);
    input.value = input.checked ? "true" : "false";
    input.setAttribute("aria-disabled", input.checked ? "true" : "false");
});
const $3abb060d6e435300$var$bios = [];
const $3abb060d6e435300$var$directorLinks = document.querySelectorAll(".director-bio-btn");
let $3abb060d6e435300$var$currentBio;
const $3abb060d6e435300$var$copyEmailBtn = document.getElementById('copyEmail');
const $3abb060d6e435300$var$viewEmailBtn = document.getElementById('viewEmail');
$3abb060d6e435300$var$copyEmailBtn?.addEventListener("click", async (evt)=>{
    const btnTarget = evt.target;
    const btn = btnTarget.parentNode;
    btn.disabled = true;
    const label = btn.querySelector("label");
    const svg = btn.querySelector("svg");
    if (svg) svg.style.display = "none";
    if (label) label.innerHTML = "Retrieving email";
    try {
        const response = await fetch(`/directors/email/${$3abb060d6e435300$var$currentDirectorId}`);
        if (response.ok) {
            const data = await response.json();
            await navigator.clipboard.writeText(data.email);
            if (label) label.innerHTML = "Email copied to your clipboard";
        } else if (label) label.innerHTML = "There was a problem, please refresh and try again.";
    } catch (err) {
        if (label) label.innerHTML = "There was a problem, please refresh and try again.";
        console.log(err);
    }
});
$3abb060d6e435300$var$viewEmailBtn?.addEventListener("click", async (evt)=>{
    const btnTarget = evt.target;
    const btn = btnTarget.parentNode;
    btn.disabled = true;
    const label = btn.querySelector("label");
    const svg = btn.querySelector("svg");
    if (svg) svg.style.display = "none";
    if (label) label.innerHTML = "Retrieving email";
    try {
        const response = await fetch(`/directors/email/${$3abb060d6e435300$var$currentDirectorId}`);
        if (response.ok) {
            const data = await response.json();
            if (label) label.innerHTML = `<a href='mailto:${data.email}'>${data.email}</a>`;
        } else if (label) label.innerHTML = "There was a problem, please refresh and try again.";
    } catch (err) {
        if (label) label.innerHTML = "There was a problem, please refresh and try again.";
        console.log(err);
    }
});
function $3abb060d6e435300$var$showBio(id) {
    const bioView = document.getElementById("bio-view");
    const userBox = document.getElementById(id);
    const btnEle = userBox?.querySelector("button");
    const nameEle = userBox?.querySelector(".title");
    const locationEle = userBox?.querySelector(".subtitle");
    const imageElement = userBox?.querySelector("img");
    const inputElement = userBox?.querySelector("input");
    const specialitiesEle = userBox?.querySelector("#specialties-data");
    const viewName = bioView?.querySelector("h3");
    const viewLocation = bioView?.querySelector(".location");
    const viewImage = bioView?.querySelector("img");
    const viewBio = bioView?.querySelector("#bio-text");
    const viewSpecialties = bioView?.querySelector(".specialties-list");
    $3abb060d6e435300$var$currentDirectorId = parseInt(id);
    if (viewName) viewName.innerHTML = nameEle?.innerHTML ?? "";
    if (viewLocation) viewLocation.innerHTML = locationEle?.innerHTML ?? "";
    if (viewImage) viewImage.src = imageElement?.src ?? "";
    if (viewBio) viewBio.innerHTML = inputElement?.value ?? "";
    if (viewSpecialties) {
        const specialtyList = specialitiesEle?.innerHTML.split("%").map((s)=>{
            return `<span class="tag is-primary">${s}</span>`;
        });
        viewSpecialties.innerHTML = specialtyList?.join("") ?? "";
    }
    bioView?.classList.add('is-active');
    const closeModalBtn = document.querySelector("#modal-close");
    closeModalBtn?.focus();
    $3abb060d6e435300$var$currentBio = id;
    showCopyEmailBtn();
    showViewEmailBtn();
    function showCopyEmailBtn() {
        const copyEmailBtn = document.querySelector("#copyEmail");
        if (copyEmailBtn) {
            copyEmailBtn.disabled = false;
            const svg = copyEmailBtn.querySelector("svg");
            const label = copyEmailBtn.querySelector("label");
            if (svg) svg.style.display = "block";
            if (label) label.innerHTML = "&nbsp;Copy Email";
        }
    }
    function showViewEmailBtn() {
        const btn = document.querySelector("#viewEmail");
        if (btn) {
            btn.disabled = false;
            const label = btn.querySelector("label");
            const svg = btn.querySelector("svg");
            if (svg) svg.style.display = "block";
            if (label) label.innerHTML = "&nbsp;View Email";
        }
    }
}
function $3abb060d6e435300$var$getBio(evt) {
    const btnElement = evt.target;
    $3abb060d6e435300$var$showBio(btnElement?.dataset.id ?? "1");
}
$3abb060d6e435300$var$directorLinks.forEach((d)=>{
    const btn = d;
    d.addEventListener("click", $3abb060d6e435300$var$getBio);
    $3abb060d6e435300$var$bios.push(btn?.dataset.id ?? "");
});
document.getElementById("modal-close")?.addEventListener("click", ()=>document.getElementById("bio-view")?.classList.remove("is-active"));
function $3abb060d6e435300$var$nextBio() {
    for(let i = 0; i < $3abb060d6e435300$var$bios.length; i++){
        if ($3abb060d6e435300$var$currentBio == $3abb060d6e435300$var$bios[$3abb060d6e435300$var$bios.length - 1]) {
            $3abb060d6e435300$var$showBio($3abb060d6e435300$var$bios[0]);
            break;
        }
        if ($3abb060d6e435300$var$currentBio == $3abb060d6e435300$var$bios[i]) {
            $3abb060d6e435300$var$showBio($3abb060d6e435300$var$bios[i + 1]);
            break;
        }
    }
}
function $3abb060d6e435300$var$previousBio() {
    for(let i = 0; i < $3abb060d6e435300$var$bios.length; i++){
        if ($3abb060d6e435300$var$currentBio == $3abb060d6e435300$var$bios[0]) {
            $3abb060d6e435300$var$showBio($3abb060d6e435300$var$bios[$3abb060d6e435300$var$bios.length - 1]);
            break;
        }
        if ($3abb060d6e435300$var$currentBio == $3abb060d6e435300$var$bios[i]) {
            $3abb060d6e435300$var$showBio($3abb060d6e435300$var$bios[i - 1]);
            break;
        }
    }
}
document.getElementById('next')?.addEventListener("click", $3abb060d6e435300$var$nextBio);
document.getElementById('previous')?.addEventListener("click", $3abb060d6e435300$var$previousBio);
document.addEventListener("keydown", $3abb060d6e435300$var$navigateBio);
function $3abb060d6e435300$var$navigateBio(evt) {
    const bioView = document.getElementById('bio-view');
    if (bioView?.classList.contains("is-active")) {
        if (evt.code === "ArrowRight") $3abb060d6e435300$var$nextBio();
        else if (evt.code == "ArrowLeft") $3abb060d6e435300$var$previousBio();
        else if (evt.code === "Escape") bioView.classList.remove("is-active");
    }
}
const $3abb060d6e435300$var$appDropdownBtn = document.getElementById('app-dropdown-btn');
$3abb060d6e435300$var$appDropdownBtn?.addEventListener("click", ()=>{
    const container = $3abb060d6e435300$var$appDropdownBtn.parentNode?.parentNode;
    container?.classList.toggle("is-active");
});


function $a9b18354ee6d203f$export$3ff8cecf0aa87c28(text) {
    const escapedDoubleQuote = text.replace('"', '"');
    const escapedSingleQuote = escapedDoubleQuote.replace("'", "'");
    //return escapedSingleQuote;
    return text;
}


let $d6836b255eb74ecf$var$registrationFormData = {
    schoolId: 0,
    courseId: 0,
    cohortId: 0,
    firstname: '',
    lastname: '',
    phone: '',
    email: '',
    street: '',
    streetExtra: '',
    city: '',
    state: '',
    zip: '',
    country: '',
    questions: [],
    activeFormPage: 0,
    activeFormQuestion: 0
};
let $d6836b255eb74ecf$var$dropdownActive = false;
function $d6836b255eb74ecf$var$toggleDropdown(evt) {
    $d6836b255eb74ecf$var$dropdownActive = true;
    evt.preventDefault();
    evt.stopPropagation();
    const dropdownSelector = evt.target;
    let dropdownBtn;
    if (dropdownSelector.tagName == "SPAN") dropdownBtn = dropdownSelector.parentNode;
    else if (dropdownSelector.tagName == "I") {
        dropdownBtn = dropdownSelector.parentElement;
        dropdownBtn = dropdownBtn?.parentElement;
    } else dropdownBtn = dropdownSelector;
    // @ts-ignore
    const targetMenuName = dropdownBtn?.dataset.id;
    const targetMenu = document.querySelector(`#${targetMenuName}`);
    if (targetMenu.classList.contains('is-active')) {
        //close
        targetMenu.classList.remove("is-active");
        const icon = targetMenu.querySelector("i");
        icon?.classList.remove("fa-angle-up");
        icon?.classList.add("fa-angle-down");
    } else {
        //open
        targetMenu.classList.add("is-active");
        const icon = targetMenu.querySelector("i");
        icon?.classList.add("fa-angle-up");
        icon?.classList.remove("fa-angle-down");
    }
}
function $d6836b255eb74ecf$var$closeAllDropdowns() {
    const dropdownTargetsList = document.querySelectorAll('.school-dropdown');
    dropdownTargetsList.forEach((d)=>{
        d.classList.remove("is-active");
        const icon = d.querySelector("i");
        icon?.classList.remove("fa-angle-up");
        icon?.classList.add("fa-angle-down");
    });
}
function $d6836b255eb74ecf$var$clearSelectors(includeCourseRest) {
    const selectedCourse = document.querySelector("#selected-course");
    const selectedCourseMenu = document.querySelector("#course-select-menu-content > .dropdown-content");
    const selectedCohort = document.querySelector("#selected-cohort");
    const selectedCohortMenu = document.querySelector("#cohort-select-menu-content > .dropdown-content");
    if (selectedCourse && includeCourseRest) {
        selectedCourse.innerHTML = "Select a Course";
        if (selectedCourseMenu) selectedCourseMenu.innerHTML = "";
    }
    if (selectedCohort) {
        selectedCohort.innerHTML = "Select a Cohort";
        if (selectedCohortMenu) selectedCohortMenu.innerHTML = "";
    }
}
function $d6836b255eb74ecf$var$dropdownItemSelect(evt) {
    $d6836b255eb74ecf$var$closeAllDropdowns();
    const selection = evt.target;
    const title = document.querySelector(`#${selection.getAttribute("data-select-title")}`);
    const propertyKey = selection.getAttribute("data-item-key");
    const propertyValue = selection.getAttribute("data-value");
    if (title) title.innerHTML = selection.innerHTML;
    $d6836b255eb74ecf$var$registrationFormData = {
        ...$d6836b255eb74ecf$var$registrationFormData,
        [propertyKey ?? ""]: propertyValue ?? ""
    };
    if (propertyKey?.includes("school")) {
        $d6836b255eb74ecf$var$clearSelectors(true);
        //load courses
        fetch(`/registration/api/courses/${propertyValue}`).then((response)=>{
            response.json().then((data)=>{
                const courseDropdown = document.querySelector("#course-field");
                if (courseDropdown) courseDropdown.classList.remove("hide");
                const listItems = data.map((c)=>{
                    return `<p data-select-title="selected-course" data-item-key="courseId" data-value="${c.id}" 
                                    class="dropdown-item dropdown-selection">${c.name}</p>`;
                });
                const dropdownList = courseDropdown?.querySelector(".dropdown-content");
                if (dropdownList) dropdownList.innerHTML = listItems.join("");
                const insertedItems = dropdownList?.querySelectorAll("p");
                insertedItems?.forEach((p)=>{
                    p.addEventListener("click", $d6836b255eb74ecf$var$dropdownItemSelect);
                });
                const cohortField = document.getElementById("cohort-field");
                if (data.hasCohorts) cohortField?.classList.remove("hide");
                else cohortField?.classList.add("hide");
                const studentInfoContainer = document.querySelector("#student-info");
                if (studentInfoContainer) studentInfoContainer.classList.add("hide");
            });
        });
    } else if (propertyKey?.includes("course")) {
        //load cohorts
        $d6836b255eb74ecf$var$clearSelectors(false);
        fetch(`/registration/api/courses/${$d6836b255eb74ecf$var$registrationFormData.schoolId}/cohorts/${propertyValue}`).then((response)=>{
            response.json().then((data)=>{
                if (data.length > 0) {
                    const cohortDropdown = document.querySelector("#cohort-field");
                    if (cohortDropdown) cohortDropdown.classList.remove('hide');
                    const listItems = data.map((c)=>{
                        return `<p data-select-title="selected-cohort" data-item-key="cohortId" data-value="${c.id}" 
                                    class="dropdown-item dropdown-selection">${c.name}</p>`;
                    });
                    const dropdownList = cohortDropdown?.querySelector(".dropdown-content");
                    if (dropdownList) dropdownList.innerHTML = listItems.join("");
                    const insertedItems = dropdownList?.querySelectorAll("p");
                    insertedItems?.forEach((p)=>{
                        p.addEventListener("click", $d6836b255eb74ecf$var$dropdownItemSelect);
                    });
                } else {
                    //show student info
                    const studentInfoContainer = document.querySelector("#student-info");
                    studentInfoContainer?.classList.remove('hide');
                }
            });
        });
    } else if (propertyKey?.includes("cohort")) {
        //show student info
        const studentInfoContainer = document.querySelector("#student-info");
        studentInfoContainer?.classList.remove('hide');
    }
}
const $d6836b255eb74ecf$var$dropdownBtns = document.querySelectorAll(".school-dropdown .dropdown-trigger button");
function $d6836b255eb74ecf$var$bindDropdownSelectors() {
    const selections = document.querySelectorAll(".dropdown-selection");
    selections.forEach((s)=>{
        s.addEventListener("click", $d6836b255eb74ecf$var$dropdownItemSelect);
    });
}
if (window.location.pathname.includes("registration")) {
    $d6836b255eb74ecf$var$dropdownBtns.forEach((schoolBtn)=>{
        schoolBtn.addEventListener("click", $d6836b255eb74ecf$var$toggleDropdown);
    });
    function updateForm(evt) {
        const form = evt.target;
        const inputs = form.querySelectorAll('input');
        inputs.forEach((inp)=>{
            const key = inp.getAttribute("data-item-key") ?? "";
            const value = inp.value;
            $d6836b255eb74ecf$var$registrationFormData = {
                ...$d6836b255eb74ecf$var$registrationFormData,
                [key]: value
            };
        });
    }
    const regForm1 = document.getElementById('registration-step-1');
    const regForm2 = document.getElementById('registration-step-2');
    const regForm3 = document.getElementById('registration-step-3');
    regForm1?.addEventListener("submit", (evt)=>{
        evt.preventDefault();
        updateForm(evt);
        showAddressPage();
    });
    regForm2?.addEventListener("submit", async (evt)=>{
        evt.preventDefault();
        updateForm(evt);
        if ($d6836b255eb74ecf$var$registrationFormData.questions.length > 0) showQuestionsPage();
        else submitApplication();
    });
    regForm3?.addEventListener("submit", (evt)=>{
        evt.preventDefault();
        updateForm(evt);
        if ($d6836b255eb74ecf$var$registrationFormData.activeFormQuestion < $d6836b255eb74ecf$var$registrationFormData.questions.length - 1) {
            $d6836b255eb74ecf$var$registrationFormData.activeFormQuestion = $d6836b255eb74ecf$var$registrationFormData.activeFormQuestion + 1;
            showQuestionsPage();
        } else submitApplication();
    });
    const prevBtns = document.querySelectorAll('.prev-btn');
    prevBtns.forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            regForm1?.classList.add('hide');
            regForm2?.classList.add('hide');
            regForm3?.classList.add('hide');
            switch($d6836b255eb74ecf$var$registrationFormData.activeFormPage){
                case 2:
                    showMainPage();
                    break;
                case 3:
                    if ($d6836b255eb74ecf$var$registrationFormData.activeFormQuestion == 0) showAddressPage();
                    else {
                        $d6836b255eb74ecf$var$registrationFormData.activeFormQuestion--;
                        showQuestionsPage();
                    }
                    break;
            }
        });
    });
    async function getQuestions() {
        const response = await fetch(`/registration/api/application/questions/${$d6836b255eb74ecf$var$registrationFormData.schoolId}`);
        const data = await response.json();
        $d6836b255eb74ecf$var$registrationFormData.questions = [
            ...data
        ];
    }
    function showMainPage() {
        regForm2?.classList.add('hide');
        const studentInfo = document.getElementById('student-info');
        studentInfo?.classList.remove('hide');
        regForm1?.classList.remove('hide');
    }
    async function showAddressPage() {
        const nextBtn = document.querySelector("#nextBtn");
        loadCountryDropdown();
        const regForm1 = document.getElementById('registration-step-1');
        regForm1?.classList.add('hide');
        await getQuestions();
        if ($d6836b255eb74ecf$var$registrationFormData.questions.length > 0) nextBtn?.classList.remove('hide');
        else {
            const submitAppBtn = document.querySelector("#submitAppBtn");
            submitAppBtn?.classList.remove('hide');
            nextBtn?.classList.add('hide');
        }
        const regForm2 = document.getElementById('registration-step-2');
        regForm2?.classList.remove('hide');
        $d6836b255eb74ecf$var$registrationFormData.activeFormPage = 2;
    }
    function showQuestionsPage() {
        const regForm2 = document.getElementById('registration-step-2');
        regForm2?.classList.add('hide');
        const data = $d6836b255eb74ecf$var$registrationFormData.questions;
        const questionTitle = document.querySelector("#question-title");
        const questionLabel = document.querySelector("#question-label");
        const answerContainer = document.querySelector("#answer");
        const currentQuestion = data[$d6836b255eb74ecf$var$registrationFormData.activeFormQuestion];
        const nextBtn = document.querySelector("#nextBtn2");
        const submitAppBtn = document.querySelector("#submitAppBtn2");
        questionTitle != null && (questionTitle.innerHTML = `Question ${$d6836b255eb74ecf$var$registrationFormData.activeFormQuestion + 1} of 
    ${data.length}`);
        if (questionLabel) questionLabel.innerHTML = currentQuestion.question;
        if (currentQuestion.answerOptions.length > 0 && answerContainer) {
            const radioBtns = currentQuestion.answerOptions.map((answer, index)=>{
                return `<p class="pt-2"><input class="question-input" type="radio" data-question-id="${currentQuestion.questionId}" value=${encodeURI(answer)} name='question-id-${currentQuestion.questionId}' />
                    <span class="pl-1">${(0, $a9b18354ee6d203f$export$3ff8cecf0aa87c28)(answer)}</span></p>
                    `;
            });
            answerContainer.innerHTML = radioBtns.join("");
        } else answerContainer != null && (answerContainer.innerHTML = `<input type="text" class="input question-input" data-question-id="${currentQuestion.questionId}" name="question-id-${currentQuestion.questionId}" />`);
        if ($d6836b255eb74ecf$var$registrationFormData.activeFormQuestion + 1 < data.length) {
            nextBtn?.classList.remove('hide');
            submitAppBtn?.classList.add('hide');
        } else {
            submitAppBtn?.classList.remove('hide');
            nextBtn?.classList.add('hide');
        }
        bindQuestionEvents();
        const regForm3 = document.getElementById('registration-step-3');
        regForm3?.classList.remove('hide');
        $d6836b255eb74ecf$var$registrationFormData.activeFormPage = 3;
    }
    // const formInputs:NodeListOf<HTMLInputElement> = document.querySelectorAll('input');
    // formInputs.forEach((inp)=>{
    //     inp.addEventListener("keyup", updateForm);
    //     inp.addEventListener("blur", updateForm);
    //     function updateForm(){
    //         const key:string = inp.getAttribute("data-item-key") ?? "";
    //         const value = inp.value;
    //         registrationFormData = {
    //             ...registrationFormData,
    //             [key]:value
    //         }
    //     }
    // })
    function bindQuestionEvents() {
        const questionInputs = document.querySelectorAll('.question-input');
        questionInputs.forEach((inp)=>{
            inp.addEventListener("change", (evt)=>updateFormData());
            inp.addEventListener("keydown", (evt)=>updateFormData());
            function updateFormData() {
                const key = inp.getAttribute("data-question-id") ?? "0";
                const questionId = parseInt(key);
                $d6836b255eb74ecf$var$registrationFormData.questions.filter((q)=>q.questionId == questionId)[0].answer = inp.value;
            }
        });
    }
    async function loadCountryDropdown() {
        const countryDropdown = document.querySelector("#country-select");
        const data = await getCountries();
        const list = data.map((c)=>{
            return `<option data-select-title="selected-country" data-item-key="country" data-value="${c.commonName}"
                               class="dropdown-item dropdown-selection">${c.commonName}</option>`;
        });
        if (countryDropdown) {
            countryDropdown.innerHTML = list.join("");
            countryDropdown.addEventListener("change", $d6836b255eb74ecf$var$dropdownItemSelect);
        }
        $d6836b255eb74ecf$var$registrationFormData.country = "United States";
        $d6836b255eb74ecf$var$bindDropdownSelectors();
    }
    async function getCountries() {
        const response = await fetch("/registration/api/countries");
        return await response.json();
    }
    async function submitApplication() {
        const submitBtn = document.querySelectorAll(".submit-app-btn");
        submitBtn.forEach((btn)=>btn.classList.add('is-loading'));
        const response = await fetch("/registration/api/submit", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify($d6836b255eb74ecf$var$registrationFormData),
            method: "POST"
        });
        const regForm2 = document.getElementById('registration-step-2');
        regForm2?.classList.add("hide");
        const regForm3 = document.getElementById('registration-step-3');
        regForm3?.classList.add("hide");
        const registrationResult = document.getElementById('registration-result');
        const successText = document.getElementById("success");
        const failText = document.getElementById("fail");
        submitBtn.forEach((btn)=>btn.classList.remove('is-loading'));
        if (response.ok) {
            if (registrationResult) registrationResult.classList.remove('hide');
        } else if (registrationResult) {
            registrationResult.classList.remove('hide');
            successText?.classList.add("hide");
            failText?.classList.remove("hide");
        }
    }
    function updateFormWithPreselectedFields() {
        const schoolIdElement = document.querySelector("#selected-school");
        const courseIdElement = document.querySelector("#selected-course");
        const cohortIdElement = document.querySelector("#selected-cohort");
        if (schoolIdElement) $d6836b255eb74ecf$var$registrationFormData.schoolId = parseInt(schoolIdElement.dataset.id ?? "0");
        if (courseIdElement) $d6836b255eb74ecf$var$registrationFormData.courseId = parseInt(courseIdElement.dataset.id ?? "0");
        if (cohortIdElement) $d6836b255eb74ecf$var$registrationFormData.cohortId = parseInt(cohortIdElement.dataset.id ?? "0");
    }
    async function temporary() {
        //go to page 3 for development
        $d6836b255eb74ecf$var$registrationFormData.schoolId = 1;
        regForm1?.classList.add('hide');
        regForm2?.classList.remove('hide');
        showAddressPage();
    //await getQuestions();
    //showQuestionsPage();
    }
    $d6836b255eb74ecf$var$bindDropdownSelectors();
    updateFormWithPreselectedFields();
//temporary();
} //on keydown add input value to formData
 //load pre-filled cohort view
 //submit
 //Remove background from page title


const $c7787332da991098$var$accordionItem = document.querySelectorAll('.accordion-list .accordion');
$c7787332da991098$var$accordionItem.forEach((item)=>{
    const listener = item.querySelector('.title-block');
    listener?.addEventListener('click', ()=>{
        const accDisplay = item.querySelector('.accordion-display');
        const accIcons = item.querySelectorAll('.accordion-icon');
        accDisplay?.classList.toggle('expand');
        accIcons.forEach((icon)=>{
            icon.classList.toggle('active');
        });
    });
});



})();
//# sourceMappingURL=index.js.map
